import * as React from 'react';

import { InlineNotification } from '@coursera/cds-core';

import _t from 'i18n!nls/personalization-settings';

type Props = {
  type: 'success' | 'error';
  /** Overrides the default save-status text, e.g. for a validation error unrelated to the save call. */
  message?: string;
};

const EditorNotification = ({ type, message }: Props) => {
  const notification =
    message ?? (type === 'success' ? _t('Update successful!') : _t('Update failed, please try again.'));

  return <InlineNotification severity={type}>{notification}</InlineNotification>;
};

export default EditorNotification;
